import Box from '@mui/material/Box';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Footer } from '../Components/Footer';
import { Navbar } from '../Components/Navbar';
import {
    BLOG_BUILDER_PATH,
    BLOG_PATH,
    CONTACT_PATH,
    FEATURED_PHOTOS_PATH,
    HOME_PATH,
    PATHFINDER_PROJECT_PATH,
    PHOTO_BUILDER_PATH,
    PHOTOS_PATH,
    SORTING_ALG_PROJECT_PATH,
    TREE_PROJECT_PATH,
} from '../constants';
import { Blog } from '../Pages/Blog';
import { BlogPostBuilder } from '../Pages/BlogPostBuilder';
import { BlogPost } from '../Pages/BlogPost';
import { Contact } from '../Pages/Contact';
import { FeaturedPhotos } from '../Pages/FeaturedPhotos';
import { Home } from '../Pages/Home';
import { Pathfinder } from '../Pages/Pathfinder';
import { PhotoCollection } from '../Pages/PhotoCollection';
import { PhotoCollectionBuilder } from '../Pages/PhotoCollectionBuilder';
import { Photos } from '../Pages/Photos';
import { TestVisualizer } from '../Projects/SortingVisualizer/SortingVisualizer';
import TreeTraverser from '../Projects/TreeTraverser/TreeTraverser';

export function Navigation() {
    return (
        <div>
            <BrowserRouter>
                <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                    <Navbar />
                    <Routes>
                        <Route path={HOME_PATH} element={<Home />} />
                        <Route path={CONTACT_PATH} element={<Contact />} />
                        <Route path={BLOG_PATH} element={<Blog />} />
                        <Route path={BLOG_BUILDER_PATH} element={<BlogPostBuilder />} />
                        <Route path={PHOTOS_PATH} element={<Photos />} />
                        <Route path={PHOTO_BUILDER_PATH} element={<PhotoCollectionBuilder />} />
                        <Route path={FEATURED_PHOTOS_PATH} element={<FeaturedPhotos />} />
                        <Route path={`${PHOTOS_PATH}/:collectionId`} element={<PhotoCollection />} />
                        <Route path={`${BLOG_PATH}/post`} element={<BlogPost />} />
                        <Route path={PATHFINDER_PROJECT_PATH} element={<Pathfinder />} />
                        <Route path={TREE_PROJECT_PATH} element={<TreeTraverser />} />
                        <Route path={SORTING_ALG_PROJECT_PATH} element={<TestVisualizer />} />
                    </Routes>
                    <Footer />
                </Box>
            </BrowserRouter>
        </div>
    );
}
